module.exports = __webpack_public_path__ + "media/assets/red-02c3a6d4271cf98ad0518e8893721391.png";